export const TrackingTabs = {
  container: 'Container',
  cargo: 'Cargo',
  courier: 'Courier',
  boe: 'BOE',
};

export const statusPrettyNameMap = {
  'on_hold': 'ON HOLD',
  'rto': 'RTO',
  'arrived': 'ARRIVED',
  'delivery': 'DELIVERY',
  'cancelled': 'CANCELLED',
  'intransittohub': 'IN TRANSIT TO HUB',
  'accept': 'OUT FOR DELIVERY',
  'created': 'CREATED',
  'pickup_completed': 'PICKUP COMPLETED',
  'in_transit': 'IN TRANSIT',
  'rts_initiated': 'RTS INITIATED',
  'archived': 'ARCHIVED',
  'out_for_pickup': 'OUT FOR PICKUP',
  'outfordeliver': 'OUT FOR DELIVERY',
  'booked_at_hub': 'BOOKED AT HUB',
  'pickup_awaited': 'PICKUP AWAITED',
  'delivered': 'DELIVERED',
  'bagged': 'BAGGED',
  'softdata_upload': 'SOFTDATA UPLOAD',
  'not_picked_up': 'NOT PICKED UP',
  'inscan_at_hub': 'INSCAN AT HUB',
  'attempted': 'ATTEMPTED',
  'reachedathub': 'REACHED AT HUB',
  'rto_delivered': 'RTO DELIVERED',
  'pickup_scheduled': 'PICKUP SCHEDULED',
  'outscan_at_hub': 'OUTSCAN AT HUB',
  'assigntoworker': 'ASSIGNED TO WORKER',
  'release_on_hold': 'RELEASED FROM HOLD',
  'lost': 'CONSIGNMENT LOST'
};
